export const StorageKey = {
  // Auth
  AUTH_TOKEN: "authToken",

  // Layout & Navigation
  NAV_EXPANDED: "isNavExpanded",
  NAV_DISMISSED_COACH_MARKS: "NAV_DISMISSED_COACH_MARKS",
  WEBSOCKETS_DISCLOSURE_ACKNOWLEDGED: "WEBSOCKETS_DISCLOSURE_ACKNOWLEDGED",

  // Theme
  THEME_PREFERENCE: "DASHBOARD_THEME_PREFERENCE",

  // Banners
  WALLET_API_LOGS_BANNER_DISMISSED: "walletApiLogsBannerDismissed",

  // Analytics (developer flags — intentionally simple for console use)
  DEBUG_ANALYTICS: "DEBUG_ANALYTICS",
  FORCE_ANALYTICS: "FORCE_ANALYTICS",
  ENABLE_ANALYTICS: "ENABLE_ANALYTICS",
} as const;

/**
 * Parameterized key builders for user-scoped or dynamic storage keys.
 * Similar to path builders — construct keys dynamically while remaining
 * centrally registered.
 */
export const storageKeyBuilders = {
  authchemyPkceState: (state: string) => `authchemy.pkce.${state}`,

  expirableEvent: (userId: number | undefined, event: string | undefined) =>
    `alchemyapi.expirableEvent.${userId ?? ""}.${event ?? ""}`,

  oneTimeEvent: (userId: number | undefined, event: string | undefined) =>
    `alchemyapi.oneTimeEvent.${userId ?? ""}.${event ?? ""}`,

  hiddenProductBanners: (userId: number | undefined) =>
    `product-launch-banners-dismissed.${userId ?? ""}`,

  composerApiKey: (userId: number | undefined) =>
    `composerApiKey:${userId ?? ""}`,
} as const;

export type StaticStorageKey = (typeof StorageKey)[keyof typeof StorageKey];
